
export const useLeadGenRecData = () => {
  const transform = (response) => {
    const { sanitize } = useUtils();
    const data = response?.data || {};
    const attributes = data?.attributes || {};
    return {
      id: data?.id ?? null,
      title: sanitize(attributes.title),
      slug: sanitize(attributes.slug),
      steps: sanitize(attributes.steps),
      customHeader: sanitize(attributes.customHeader),
      tagsArray: sanitize(attributes.tagsArray),
      seo: sanitize(attributes.seo),
      submitBtnTitle: sanitize(attributes.submitBtnTitle)
    }
  }
  
  const getRecPageBySlug = async (slug) => {    
    const {findOneBySlug} = useStrapiAsyncData();
    const url = 'lead-gen-recs';
    const params = {
      slug: slug,
      entity: 'lead-gen-recs'
    }
    return findOneBySlug(url, params, transform);
  }

  const getRecShared = async () => {
    return await useFetch('/api/lead-gen-shared-config')
  }
  
  return {
      getRecPageBySlug,
      getRecShared
  }
}